var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-component"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"blue","size":"24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }